import { BasicChildSupportObligationTableData } from "./obligationTableData";
import { BasicChildSupportObligationOLDTableData } from "./OLD_ObligationTableData";

export const CalculateNearestChildValues = (
  totalIncome: number,
  numberOfChildren: number,
  WorkSheetCreatedDate: string
) => {
  let nearestRecord;
  const finalWorksheetCreatedData = WorkSheetCreatedDate
    ? WorkSheetCreatedDate
    : new Date().toISOString();
  const cutOffDate = new Date("2024-07-01T00:00:00Z"); /// Cut-off date (01-07-2024)
  const worksheetDate = new Date(finalWorksheetCreatedData);
  let obligationValue = 0;

  // Choose the correct data table based on the date comparison
  const checkBasicOldTable = worksheetDate < cutOffDate;
  const BasicChildSupportObligationData =
    worksheetDate < cutOffDate
      ? BasicChildSupportObligationOLDTableData
      : BasicChildSupportObligationTableData;

  // Check if totalIncome is negative or below 800
  if (totalIncome < 800) {
    const firstRecord = BasicChildSupportObligationData.reduce((prev, curr) =>
      parseFloat(curr.adjusted.replace(/,/g, "")) <
      parseFloat(prev.adjusted.replace(/,/g, ""))
        ? curr
        : prev
    );
    switch (numberOfChildren) {
      case 1:
        obligationValue = parseFloat(firstRecord.one_child.replace(/,/g, ""));
        break;
      case 2:
        obligationValue = parseFloat(
          firstRecord.two_children.replace(/,/g, "")
        );
        break;
      case 3:
        obligationValue = parseFloat(
          firstRecord.three_children.replace(/,/g, "")
        );
        break;
      case 4:
        obligationValue = parseFloat(
          firstRecord.four_children.replace(/,/g, "")
        );
        break;
      case 5:
        obligationValue = parseFloat(
          firstRecord.five_children.replace(/,/g, "")
        );
        break;
      case 6:
        obligationValue = parseFloat(
          firstRecord.six_children.replace(/,/g, "")
        );
        break;
      default:
        obligationValue = parseFloat(firstRecord.one_child.replace(/,/g, ""));
        break;
    }

    return obligationValue;
  }

  let nearestValues: typeof BasicChildSupportObligationData = [];

  if (totalIncome > 40000) {
    if (checkBasicOldTable) {
      nearestRecord = BasicChildSupportObligationData.find(
        (record) => parseFloat(record.adjusted.replace(/,/g, "")) === 30000
      );
    } else {
      // If totalIncome is more than 40,000, use the record with adjusted value "40,000.00"
      nearestRecord = BasicChildSupportObligationData.find(
        (record) => parseFloat(record.adjusted.replace(/,/g, "")) === 40000
      );
    }
  } else {
    const lastTwoDigits = totalIncome % 100;

    if (checkBasicOldTable && totalIncome > 30000) {
      // Old table logic for income > 30,000
      nearestRecord = BasicChildSupportObligationData.find(
        (record) => parseFloat(record.adjusted.replace(/,/g, "")) === 30000
      );
    } else {
      // General nearest record logic
      nearestValues = BasicChildSupportObligationData.filter((record) => {
        const adjustedValue = parseFloat(record.adjusted.replace(/,/g, ""));
        return (
          adjustedValue <= totalIncome + 25 && adjustedValue >= totalIncome - 25
        );
      });

      if (nearestValues.length > 0) {
        if (lastTwoDigits >= 25 && lastTwoDigits < 50) {
          nearestRecord =
            nearestValues.find(
              (record) =>
                parseFloat(record.adjusted.replace(/,/g, "")) > totalIncome
            ) || nearestValues[nearestValues.length - 1];
        } else if (lastTwoDigits >= 50 && lastTwoDigits < 75) {
          nearestRecord =
            nearestValues.find(
              (record) =>
                parseFloat(record.adjusted.replace(/,/g, "")) > totalIncome
            ) || nearestValues[nearestValues.length - 1];
        } else if (lastTwoDigits >= 75) {
          nearestRecord =
            nearestValues.find(
              (record) =>
                parseFloat(record.adjusted.replace(/,/g, "")) > totalIncome
            ) || nearestValues[nearestValues.length - 1];
        } else {
          nearestRecord =
            nearestValues.find(
              (record) =>
                parseFloat(record.adjusted.replace(/,/g, "")) <= totalIncome
            ) || nearestValues[0];
        }
      }
    }
  }

  if (!nearestRecord) {
    return (nearestRecord = 0);
    // throw console.error("No matching record found for the given total income.");
  }

  if (numberOfChildren > 6) {
    obligationValue = parseFloat(nearestRecord.six_children.replace(/,/g, ""));
  } else {
    switch (numberOfChildren) {
      case 1:
        obligationValue = parseFloat(nearestRecord.one_child.replace(/,/g, ""));
        break;
      case 2:
        obligationValue = parseFloat(
          nearestRecord.two_children.replace(/,/g, "")
        );
        break;
      case 3:
        obligationValue = parseFloat(
          nearestRecord.three_children.replace(/,/g, "")
        );
        break;
      case 4:
        obligationValue = parseFloat(
          nearestRecord.four_children.replace(/,/g, "")
        );
        break;
      case 5:
        obligationValue = parseFloat(
          nearestRecord.five_children.replace(/,/g, "")
        );
        break;
      case 6:
        obligationValue = parseFloat(
          nearestRecord.six_children.replace(/,/g, "")
        );
        break;
      default:
        obligationValue = parseFloat(nearestRecord.one_child.replace(/,/g, ""));
        break;
    }
  }

  return obligationValue;
};